<div class="lg:text-lg font-semibold text-black">Kontaktanlässe</div>
<span class="text-xs lg:text-sm text-lightText">Zu welchen Anlässen möchten Sie von uns kontaktiert werden?</span>

<div class="grid grid-cols-2 lg:gap-x-8 gap-y-4 w-full mt-2 text-lightText">
  @for (contactEvent of filteredContactEvents; track contactEvent.eventName) {
    <div class="flex gap-2 lg:gap-4 items-center">
      <div class="flex gap-1">
        <app-checkbox-icon
          [imageClass]="getContactEventIcon(contactEvent, 'unchecked')"
          class="cursor-pointer"
          (click)="change(contactEvent, ConsentStatus.WITHDRAWN)"
        />
        <app-checkbox-icon
          [imageClass]="getContactEventIcon(contactEvent, 'checked')"
          class="cursor-pointer"
          (click)="change(contactEvent, ConsentStatus.CONFIRMED)"
        />
      </div>
      <label>{{ contactEvent.displayName }}</label>
    </div>
  }
</div>
